"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudFileStatus = exports.isSFTP = void 0;
const isSFTP = (cfg) => {
    return cfg !== null && 'type' in cfg && 'address' in cfg && 'user' in cfg && 'path' in cfg;
};
exports.isSFTP = isSFTP;
var CloudFileStatus;
(function (CloudFileStatus) {
    CloudFileStatus["TO_INSERT"] = "to_insert";
    CloudFileStatus["TO_UPDATE"] = "to_update";
    CloudFileStatus["TO_REMOVE"] = "to_remove";
})(CloudFileStatus = exports.CloudFileStatus || (exports.CloudFileStatus = {}));
